<template>
    <div>
        <div class="row">
            <div @click="showBuyingFxn" class="col-12 btn btn-light text-left text-dark-green h5 mt-1">
                <i class="far fa-comment-alt"></i> Buying
                <i v-if="showBuying" class="fas fa-caret-up"></i>
                <i v-else class="fas fa-caret-down"></i>
            </div>
        </div>
        <div v-if="showBuying">
            <template v-if="myBuyings">
                <div v-for="(item, i) in myBuyings" :key="i" class="row pb-3">
                    <div class="col-md-3 col-2 text-center">
                        <!-- item photo -->
                        <router-link :to="{ name: 'listItem', params: { id: item.itemId} }">
                            <div v-if="item.itemPhoto" v-bind:style="{ backgroundImage: 'url(' + itemMainPhoto(item.itemPhoto) + ')' }" 
                            class="item-message-photo" :title="`${item.itemTitle} - www.anewitem.com`"></div>
                            <i v-else class="far fa-image fa-3x"></i>
                        </router-link>
                    </div>
                    <div class="col-md-9 col-10 message-items" v-bind:class="{ 'active-message-item': item.itemId == selectedItem && dropdown }">
                        <span @click="showBuyingThread(item.seller.sellerId, item.itemId)">
                            <p class="font-weight-bold m-0 text-truncate active-message-item-text">#{{i+1}}. {{item.itemTitle | capitalize}}</p>
                            <p class="text-dark-green active-message-item-text text-capitalize">
                                <i class="far fa-user-circle contact-message-photo-icon"></i> {{item.seller.name}} 
                                <span v-if="item.seller.unreadMsg > 0" class="badge badge-warning">{{item.seller.unreadMsg}}</span>
                            </p>
                            <hr class="m-0">
                        </span>
                    </div>
                </div>
            </template>
        </div>
        <div class="row">
            <div @click="showSellingFxn" class="col-12 btn btn-light text-left text-dark-green h5 mt-1">
                <i class="far fa-comment-alt"></i> Selling
                <i v-if="showSelling" class="fas fa-caret-up"></i>
                <i v-else class="fas fa-caret-down"></i>
            </div>
        </div>
        <div v-if="showSelling">
            <template v-if="mySellings">
                <div v-for="(item, i) in mySellings" :key="i" class="row pb-3">
                    <div class="col-md-3 col-2 text-center">
                        <!-- item photo -->
                        <router-link :to="{ name: 'listItem', params: { id: item.itemId} }">
                            <div v-if="item.itemPhoto" class="item-message-photo" v-bind:style="{ backgroundImage: 'url(' + itemMainPhoto(item.itemPhoto) + ')' }" :title="`${item.itemTitle} - www.anewitem.com`"></div>
                            <i v-else class="far fa-image fa-3x"></i>
                        </router-link>
                    </div>
                    <div class="col-md-9 col-10 message-items" v-bind:class="{ 'active-message-item': item.itemId == selectedItem && dropdown }">
                        <span @click="clickedItem(item.itemId)">
                            <p class="font-weight-bold m-0 text-truncate active-message-item-text">#{{i+1}}. {{item.itemTitle | capitalize}}</p>
                            <p class="text-dark-green active-message-item-text">{{countItemBuyers(item.buyers)}}</p>
                            <hr class="m-0">
                        </span>
                        <!-- display contacts -->
                        <app-contacts :key="forceReloadKey" v-if="item.itemId == selectedItem && dropdown" :itemId="item.itemId" :buyers="item.buyers"></app-contacts>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { appendImgHostUrl } from '@/store/dry'

import Contacts from './Contacts.vue'

export default {
    name: "Sidebar",
    data() {
        return {
            selectedItem: 0,
            itemClicksArr: [],
            dropdown: false,
            showBuying: false,
            showSelling: false,
            forceReloadKey: 0
        }
    },
    methods: {
        ...mapActions(['fetchItemBuyers', 'fetchItemsSeller', 'fetchMsgThread']),
        clickedItem(value){
            // first hide show buying
            // this.showBuying = false

            // store the clicked items into an array for tracking
            this.itemClicksArr.push(value)
            this.selectedItem = value

            // get the last two clicked item no and compare with the current click value
            let lastClicked = this.itemClicksArr.slice(-2)[0]
            
            // check if user clicked on the same item number twice, then toggle
            if(lastClicked != 0 && lastClicked == value){
                return this.dropdown = !this.dropdown
            }
            // automatically dropdown list of buyers under an item in first click
            this.dropdown = true
        },
        itemMainPhoto(path) {
            if(!path) return ''
            return appendImgHostUrl(path)
        },
        countItemBuyers(buyersArr) {
            let count = buyersArr.length
            if(count > 1){
                return `${count} Interested buyers`
            }
            return `${count} Interested buyer`
        },
        showBuyingFxn() {
            // this.showSelling = false
            this.showBuying = !this.showBuying
        },
        showSellingFxn() {
            // this.showBuying = false
            this.showSelling = !this.showSelling
        },
        showBuyingThread(sellerId, itemId) {
            let threadObj = {
                buyerId: this.user._id,
                sellerId: sellerId,
                itemId: itemId,
                receiverId: this.user._id
            }
            this.fetchMsgThread(threadObj).then(() => {}).catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['user', 'itemBuyers', 'itemsSeller', 'msgThread']),
        myBuyings() {
            if(this.itemsSeller && this.itemsSeller !== null){
                return this.itemsSeller
            }
            return false
        },
        mySellings() {
            if(this.itemBuyers && this.itemBuyers !== null){
                return this.itemBuyers
            }
            return false
        },
    },
    watch: {
        msgThread(){
            this.forceReloadKey += 1
        }
    },
    components: {
        appContacts: Contacts
    },
    created() {
        this.fetchItemBuyers().then(() => {}).catch((e) => {})
        this.fetchItemsSeller().then(() => {}).catch((e) => {})
    }
}
</script>